/**
 * Класс текущей вкладки.
 */
const CLASS_CURRENT = 'current';

/**
 * Инициализирует вкладки.
 */
function initTabs(): void
{
	const tabsList = document.querySelector( 'main>div.view>div.gallery>ul.tabs' );
	
	if ( !tabsList )
	{
		return;
	}
	
	let lastTabSection: HTMLElement = document.querySelector(
		'main>div.view>div.gallery>section.tab.current',
	) as HTMLElement;
	let lastTabItem: HTMLElement = tabsList.querySelector(
		'li.current',
	) as HTMLElement;
	
	const onTabClick = ( event: MouseEvent ) =>
	{
		const target = event.target as HTMLAnchorElement;
		const href = target.getAttribute( 'href' ) || '';
		
		if (
			( target.tagName !== 'A' )
			|| ( href[0] !== '#' )
		)
		{
			return;
		}
		
		event.preventDefault();
		
		const tab = document.getElementById( href.substr( 1 ) );
		
		if ( !tab )
		{
			return;
		}
		
		if ( lastTabItem )
		{
			lastTabItem.classList.remove( CLASS_CURRENT );
		}
		
		if ( lastTabSection )
		{
			lastTabSection.classList.remove( CLASS_CURRENT );
		}
		
		// tslint:disable-next-line:no-non-null-assertion
		lastTabItem = target.parentElement!;
		lastTabSection = tab;
		
		lastTabItem.classList.add( CLASS_CURRENT );
		lastTabSection.classList.add( CLASS_CURRENT );
	};
	
	tabsList.addEventListener( 'click', onTabClick );
}

/**
 * Module.
 */
export {
	initTabs as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/Card/initTabs.ts